import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedLpnIndexController extends Controller {
  @tracked page = 1;
  @tracked limit = 50;

  queryParams = ['page', 'limit'];
}
